import React from 'react';
import RouteMenu from 'mrf/view/MenuRoute';
import PublicKeyList from './PublicKeyList';


export default function PublicKey({ match }) {
    return (
        <RouteMenu match={match} indexComponent={PublicKeyList}>
        </RouteMenu>
    );
}